// File: src/pages/auth/ResetPasswordPage.jsx
import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';

export default function ResetPasswordPage() {
    const location = useLocation();
    const navigate = useNavigate();
    
    // Lấy email được truyền sang từ trang Quên Mật Khẩu
    const emailFromState = location.state?.email || '';

    const [formData, setFormData] = useState({ 
        email: emailFromState, 
        otp: '', 
        newPassword: '', 
        confirmPassword: '' 
    });
    const [message, setMessage] = useState({ type: '', text: '' });
    const [isLoading, setIsLoading] = useState(false);
    const [showPass, setShowPass] = useState(false);

    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ type: '', text: '' });

        if (!formData.email) {
            return setMessage({ type: 'error', text: 'Lỗi: Không tìm thấy Email. Vui lòng quay lại bước trước.' });
        }
        if (formData.newPassword !== formData.confirmPassword) {
            return setMessage({ type: 'error', text: 'Mật khẩu mới không khớp!' });
        }
        if (formData.newPassword.length < 6) {
            return setMessage({ type: 'error', text: 'Mật khẩu phải có ít nhất 6 ký tự.' });
        }

        setIsLoading(true);
        try {
            const res = await fetch(`${API_URL}/api/auth/reset-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    email: formData.email, 
                    otp: formData.otp, 
                    newPassword: formData.newPassword 
                })
            });

            const data = await res.json();
            if (!res.ok) throw new Error(data.message);

            setMessage({ type: 'success', text: 'Đặt lại mật khẩu thành công! Đang chuyển hướng về trang Đăng nhập...' });
            
            // Thành công thì cho quay lại Login sau 2 giây
            setTimeout(() => navigate('/login'), 2000); 
        } catch (error) {
            setMessage({ type: 'error', text: error.message });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex justify-center items-center pt-24 pb-12 px-4">
            <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow-sm border border-gray-100 text-center">
                <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="material-symbols-outlined text-3xl">mark_email_read</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Đặt lại mật khẩu</h2>
                <p className="text-gray-500 text-sm mb-6">Mã OTP đã được gửi đến <br/><span className="font-bold text-gray-700">{formData.email || 'Email của bạn'}</span></p>

                {message.text && (
                    <div className={`p-4 mb-6 rounded-lg text-sm font-medium ${message.type === 'success' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
                        {message.text}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-5 text-left" autoComplete="off">
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Mã xác thực OTP (6 số)</label>
                        <input 
                            type="text" 
                            name="otp" 
                            value={formData.otp} 
                            onChange={handleChange} 
                            required 
                            maxLength="6"
                            placeholder="Nhập mã 6 số từ email"
                            className="w-full p-3 bg-gray-50 border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:border-blue-500 text-center font-bold tracking-widest" 
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Mật khẩu mới</label>
                        <div className="relative">
                            <input 
                                type={showPass ? "text" : "password"} 
                                name="newPassword" 
                                value={formData.newPassword} 
                                onChange={handleChange} 
                                required 
                                autoComplete="new-password"
                                className="w-full p-3 pr-10 bg-gray-50 border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:border-blue-500" 
                            />
                            <span 
                                className="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer select-none"
                                onClick={() => setShowPass(!showPass)}
                            >
                                {showPass ? 'visibility_off' : 'visibility'}
                            </span>
                        </div>
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1">Xác nhận mật khẩu mới</label>
                        <div className="relative">
                            <input 
                                type={showPass ? "text" : "password"} 
                                name="confirmPassword" 
                                value={formData.confirmPassword} 
                                onChange={handleChange} 
                                required 
                                autoComplete="new-password"
                                className="w-full p-3 pr-10 bg-gray-50 border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:border-blue-500" 
                            />
                        </div>
                    </div>

                    <button type="submit" disabled={isLoading} className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg transition-colors mt-2">
                        {isLoading ? 'Đang xử lý...' : 'Xác nhận Đổi mật khẩu'}
                    </button>
                </form>

                <div className="mt-6 text-center">
                    <Link to="/forgot-password" className="text-sm font-semibold text-gray-500 hover:text-blue-600 flex items-center justify-center gap-1">
                        <span className="material-symbols-outlined text-sm">arrow_back</span> Gửi lại email khác
                    </Link>
                </div>
            </div>
        </div>
    );
}